import Order from "@/views/dashboard/models/Order";
import Role from "@/views/dashboard/models/Role";
export default {
  orders: 'Orders',
  filter_field: 'Filter:',
  no_filter_selected: 'No filter selected.',
  send_to_warehouse: 'Send to warehouse',
  export_orders: 'Export orders',
  import_orders: 'Import orders',
  status_dialog: {
    title: 'Change status',
    text: 'Are you sure you want to change the status to {type}'
  },
  bulk_edit_form: {
    order_status: {
      placeholder: 'Select order status',
      set_for_selected_orders: 'Set status for {count} orders to',
      apply_button: 'Apply'
    },
    call_status: {
      placeholder: 'Select call status',
      set_for_selected_orders: 'Set call status for {count} orders to',
      apply_button: 'Apply'
    }
  },
  order_call_agent: {
    placeholder: 'Select call agent',
    set_for_selected_call_agents: 'Set call agent for {count} orders to',
    apply_button: 'Apply'
  },
  global_payment_statuses: {
    [Order.WAREHOUSE_PAID_STATUS]: 'Paid warehouses',
    [Order.SELLER_PAID_STATUS]: 'Paid sellers',
    [Order.WAREHOUSE_NOT_PAID_STATUS]: 'Not Paid warehouses',
    [Order.SELLER_NOT_PAID_STATUS]: 'Not Paid sellers'
  },
  sent_to_remote_system: {
    [Role.WAREHOUSE_ROLE]: 'Sent to Warehouse',
    [Role.ADVERTISER_ROLE]: 'Sent to Advertiser'
  },
  private_payment_statuses: {
    [Order.WAREHOUSE_PAID_STATUS]: 'Paid',
    [Order.SELLER_PAID_STATUS]: 'Paid',
    [Order.WAREHOUSE_NOT_PAID_STATUS]: 'Not Paid',
    [Order.SELLER_NOT_PAID_STATUS]: 'Not Paid'
  },
  filter: {
    search: {
      placeholder: 'Filter orders ...',
      display_name: 'Search'
    },
    date: {
      placeholder: 'Select a date',
      display_name: 'Date'
    },
    users: {
      option_all: 'All Seller',
      display_name: 'Seller'
    },
    countries: {
      option_all: 'All countries',
      display_name: 'Country'
    },
    warehouses: {
      option_all: 'All warehouses',
      display_name: 'Warehouse'
    },
    call_agents: {
      option_all: 'All call agents',
      display_name: 'Call Agent'
    },
    products: {
      option_all: 'All products',
      display_name: 'Product'
    },
    status: {
      display_name: 'Status'
    },
    payment: {
      display_name: 'Show only to'
    },
    is_sent_to_remote_system: {
      display_name: 'Show only to'
    },
    offer_type: {
      display_name: 'Payment Type'
    }
  },
  order_form: {
    title: 'Order Details',
    subtitle: 'view or update order details',
    fields: {
      order_id: {
        title: 'Order ID'
      },
      page_link: {
        title: 'Sale page link'
      },
      order_date: {
        title: 'Order date'
      },
      client_ip_address: {
        title: 'Client ip address'
      },
      client_name: {
        title: 'Customer Name',
        placeholder: 'type the customer name'
      },
      client_email: {
        title: 'Customer Email'
      },
      client_phone: {
        title: 'Phone Number',
        placeholder: 'type the phone number'
      },
      payment_type: {
        title: 'Payment by'
      },
      payment_id: {
        title: 'Payment id'
      },
      client_country: {
        title: 'Client Country'
      },
      country: {
        title: 'Country'
      },
      client_region: {
        title: 'Region',
        placeholder: 'Select region'
      },
      client_other_region: {
        title: 'Other Region',
        placeholder: 'type other region'
      },
      client_city: {
        title: 'City',
        placeholder: 'Select city'
      },
      client_other_city: {
        title: 'Other City',
        placeholder: 'type other city'
      },
      client_address: {
        title: 'Delivery Address',
        placeholder: 'type delivery address'
      },
      client_zip_code: {
        title: 'Zip Code',
        placeholder: 'type zip code'
      },
      main_offer: {
        title: 'Main Offer'
      },
      payout: {
        title: 'Payout'
      },
      total_amount: {
        title: 'Total'
      },
      total_amount_in_usd: {
        title: 'Total in USD'
      },
      store_upsell: {
        title: 'Store Upsell'
      },
      call_upsell: {
        title: 'Call Upsell'
      },
      total_amount_confirmed: {
        title: 'Total Confirmed'
      },
      total_amount_confirmed_in_usd: {
        title: 'Total Confirmed in USD'
      },
      tracking_code: {
        title: 'Tracking Code',
        placeholder: 'type the tracking code'
      },
      tracking_link: {
        title: 'Tracking Link',
        placeholder: 'type the tracking link'
      },
      order_call_status: {
        title: 'Order Call Status',
        option: 'Select call status'
      },
      order_call_comment: {
        title: 'Order Call Comment',
        placeholder: 'Enter your comment here...'
      },
      order_call_shipping_notes: {
        title: 'Order Call Shipping Notes',
        placeholder: 'Enter your shipping notes here...'
      }
    },
    order_notes: {
      title: 'Private Notes',
      subtitle: 'Saved notes about customer order',
      table: {
        date: {
          title: 'Date'
        },
        note: {
          title: 'Notes'
        }
      },
      form: {
        content: {
          title: 'Note Content',
          placeholder: 'Add new notes here'
        },
        buttons: {
          add: 'Add Notes'
        }
      }
    },
    order_lines: {
      title: 'Order Lines',
      subtitle: 'Order lines details',
      table: {
        product_type: 'Product Type',
        product: 'Product',
        sku: 'SKU',
        quantity: 'Quantity',
        confirmed_quantity: 'Confirmed Quantity',
        price_and_currency: 'Price and Currency',
        confirmed_price: 'Confirmed Price'
      }
    },
    order_customer_call_history: {
      title: 'Customer Call History',
      subtitle: 'Customer calls made by call agent',
      table: {
        status: 'Status',
        comment: 'Comment',
        called_at: 'Called at'
      },
      buttons: {
        add: 'Add comment'
      }
    },
    shipping_dialog: {
      title: 'Shipping info'
    },
    buttons: {
      open_edit: 'Open edit',
      close_edit: 'Close edit',
      no_answer_order: 'Not answered',
      save_order: 'Save',
      cancel_order: 'Cancel',
      confirm_order: 'Confirm',
      deliver_order: 'Deliver',
      ship_order: 'Ship',
      return_order: 'Return',
      sent_to_warehouse: 'Send to warehouse',
      send_to_sheets: 'Send To Google Sheet'
    }
  },
  order_table: {
    actions: 'Actions',
    order_id: 'Order ID',
    date_and_time: 'Date and Time',
    customer_name: 'Customer',
    phone_number: 'Phone Number',
    address: 'Address',
    main_product: 'Product',
    total_items: 'Total items',
    earnings: 'Earnings',
    order_seller: 'Seller',
    total_amount: 'Total',
    total_amount_confirmed: 'Total Amount',
    total_in_usd: 'Total in USD',
    total_confirmed_in_usd: 'Total Confirmed in USD',
    payout: 'Payout',
    offer_name: 'Offer',
    country: 'Country',
    call_status: 'Call Status',
    sent_to_google_sheet: {
      title: 'Is sent to Google Sheet?',
      sent_to_all_google_sheets: 'Order sent to all google sheets.',
      sent_only_to: 'Order sent only to:',
      sent_to_none: 'This order has not been sent to any google sheet.'
    },
    call_comment: 'Comment',
    status: 'Order Status',
    payment_status: 'Payment Status',
    tracking: 'Tracking',
    store_upsell: 'Store Upsell ?',
    call_upsell: 'Call Upsell ?',
    warehouse_paid: 'Warehouse Paid ?',
    seller_paid: 'Seller Paid ?',
    payment: 'Payment',
    agent: 'Agent',
    sent_to_warehouse: 'Sent to warehouse ?'
  }
};